import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dropdown, Text } from '@adc/ui-core'
import _cx from 'classnames/bind'
import cls from '../styles.scss'
const cx = _cx.bind(cls)

const PurchaseProfileSelector = ({
  defaultPurchaseProfile,
  dropdownOptions,
  handleOnChangePurchaseProfile,
  selectedPurchaseProfile,
  isRequired,
  createLink,
  disabled,
}) => {
  return (
    <div className={cx('u-mb-3')}>
      <Text
        as='span'
        size='tiny'
        color='gray'
        weight='heavy'
        children='Select Purchase Profile'
      />
      <Dropdown
        placeholder='No Profile Selected'
        options={dropdownOptions}
        value={selectedPurchaseProfile}
        defaultValue={defaultPurchaseProfile}
        onChange={handleOnChangePurchaseProfile}
        className={cx('purchase-profile-dropdown')}
        noResultsMessage='No purchase profiles available'
        disabled={disabled}
        fluid
        selection
        closeOnChange
      />
      {createLink && (
        <div className={cx('button-container')}>
          <div className={cx('u-mt-3', 'u-mb-1')}>
            <Button
              className={cx('create-profile-button')}
              link={createLink}
              role='navigation'
              target='_BLANK'
              rel='noreferrer'
            >
              Create a purchase profile
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

PurchaseProfileSelector.propTypes = {
  dropdownOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  createLink: PropTypes.string.isRequired,
  handleOnChangePurchaseProfile: PropTypes.func,
  defaultPurchaseProfile: PropTypes.string,
  selectedPurchaseProfile: PropTypes.string,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default PurchaseProfileSelector
